import { render, staticRenderFns } from "./IncomeState.vue?vue&type=template&id=8002fe68&scoped=true"
import script from "./IncomeState.vue?vue&type=script&lang=ts"
export * from "./IncomeState.vue?vue&type=script&lang=ts"
import style0 from "./IncomeState.vue?vue&type=style&index=0&id=8002fe68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8002fe68",
  null
  
)

export default component.exports